import Swal from 'sweetalert2';

const premiumDefaults = {
  confirmButtonColor: '#00A8BC',
  cancelButtonColor: '#6B7780',
  confirmButtonText: 'حسنا',
  reverseButtons: true,
  focusConfirm: true,
  buttonsStyling: true,
  customClass: 'premium-swal-popup',
};

/** Shared SweetAlert instance — use across the app for consistent premium dialogs */
const swal = Swal.mixin(premiumDefaults);

export default swal;
export { premiumDefaults };
